import React from 'react'
import MainStructure from '../components/general/MainStructure'
import { useNavigate } from 'react-router-dom'
 
import { useContext , useState, useRef, useEffect} from 'react'
import { useAuth } from '../AuthContext'

import { faRobot, faStar, faRocket, faFaceSmile, faUpRightAndDownLeftFromCenter, faDownLeftAndUpRightToCenter, faDumbbell, faCog, faWandMagic, faUserTie, faFlagCheckered, faLightbulb, faFont, faSmile } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { Button, Modal } from 'react-bootstrap';
import Spinner from 'react-bootstrap/Spinner';
import { toast } from 'react-toastify';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as Icon from 'react-feather';
import LoadingSpinner from '../components/LoadingSpinner/LoadingSpinner'
import ImageUploader from './ImageUploader'
import VideoUploader from './VideoUploader'

import ximage from "../assets/twitter.png"
import linkedinimage from "../assets/linkedin.png"
import youtubeimage from "../assets/youtube.png"
import tiktok from "../assets/tiktok.png"
import instagram from "../assets/instagram.png"
import pinterest from "../assets/pinterest.png"

import threadsimage from "../assets/threads.png"
import facebookimage from "../assets/facebook.png"
import blueskyimage from "../assets/bluesky.png"
import discordimage from "../assets/discord.png"

import vidd from "../assets/vidd.png";
import teext from "../assets/file.png";

import PostInspirationCard from './components/PostInspiration'
import TimezoneSelector from './components/TimezoneSelector'
import MediaPicker from './MediaPicker'

  function zuluToDate(zuluDate) {
    // Create a new Date object from the Zulu date string
    const date = new Date(zuluDate);
  
    // Extract the date components
    const year = date.getUTCFullYear();
    const month = ('0' + (date.getUTCMonth() + 1)).slice(-2);
    const day = ('0' + date.getUTCDate()).slice(-2);
    const hours = ('0' + date.getUTCHours()).slice(-2);
    const minutes = ('0' + date.getUTCMinutes()).slice(-2);
    const seconds = ('0' + date.getUTCSeconds()).slice(-2);
  
    // Construct the formatted date string
    const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  
    return formattedDate;
  }

  const formatContentWithBreaks = (content) => {
    return content.split('\n').map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index < content.length - 1 && <br />} {/* Add <br/> except for the last line */}
      </React.Fragment>
    ));
  };



function AccountAvatar({ src, name, size = 36 }) {
  const [failed, setFailed] = React.useState(false);
  const letter = (typeof name === 'string' && name ? name[0] : '?').toUpperCase();
  const colors = ['#e0f2fe','#dcfce7','#fef9c3','#fce7f3','#ede9fe','#ffedd5'];
  const textColors = ['#0369a1','#15803d','#a16207','#9d174d','#6d28d9','#c2410c'];
  const idx = Math.abs((letter.charCodeAt(0) || 65) - 65) % colors.length;
  if (failed || !src) {
    return (
      <div style={{ width: size, height: size, borderRadius: '50%', flexShrink: 0, background: colors[idx], display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: size * 0.4, fontWeight: 700, color: textColors[idx] }}>
        {letter}
      </div>
    );
  }
  return <img src={src} alt={name} style={{ width: size, height: size, borderRadius: '50%', display: 'block', objectFit: 'cover', flexShrink: 0 }} onError={() => setFailed(true)} />;
}

function WritePost()
{

    const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const contentCenterPostId = queryParams.get('content-center-post-id');

const [showMediaPicker, setShowMediaPicker] = useState(false);
// Separate flag for the Story Post (text_image) image picker so it never
// shares state with the video picker above.
const [showImagePicker, setShowImagePicker] = useState(false);

      const [postInspiration, setpostInspiration] = useState(null);

  async function fetchSocialPostById(postId) {
  try {
    const response = await fetch(
      `https://api.schedpilot.com/wp-json/custom/v1/social-post/${postId}`,
      {
        method: 'GET',
        credentials: 'include', // 🔑 This ensures cookies (like WP nonce / session) are sent
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    console.log('Fetched post:', data);

    setpostInspiration(data);
    setText(data.text);

    return data;
  } catch (error) {
    console.error('Error fetching social post:', error);
    return null;
  }
}

const [timezone, setTimezone] = useState(Intl.DateTimeFormat().resolvedOptions().timeZone);

// ── Approval workflow ──
const [requireApproval,     setRequireApproval]     = useState(false);
const [approvalEmail,       setApprovalEmail]       = useState('');
const [emailSuggestions,    setEmailSuggestions]    = useState([]);
const [showEmailSuggestions,setShowEmailSuggestions]= useState(false);
const suggestionTimer = useRef(null);


useEffect(() => {
  const fetchUserTimezone = async () => {
    try {
      const response = await fetch('https://api.schedpilot.com/wp-json/schedpilot/v1/get-settings', {
        method: 'GET',
        credentials: 'include',
      });
      const data = await response.json();
      if (response.ok && data.timezone) {
        setTimezone(data.timezone);
      }
    } catch (err) {
      console.error("Could not load preferred timezone", err);
    }
  };
  fetchUserTimezone();
}, []);

 


    useEffect(() => {
    if (contentCenterPostId) {
      console.log('Post ID from Content Center:', contentCenterPostId);
      // You could fetch the post data here if needed
      setwhatPostType("text_image")
      fetchSocialPostById(contentCenterPostId);
    }
  }, [contentCenterPostId]);

  // A video sent over from the Video Editor ("Schedule this video"): preselect it
  // as a video post. Clear the navigation state so a refresh doesn't re-add it.
  useEffect(() => {
    const pv = location.state?.presetVideo;
    if (pv && pv.id) {
      setwhatPostType("video_post");
      setUploadedVideos([{ id: pv.id, file_url: pv.file_url, title: pv.title }]);
      window.history.replaceState({}, document.title);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);






      const [uploadedImages, setUploadedImages] = useState([]);

      const removeImage = (indexToRemove) => {
        setUploadedImages(prev => prev.filter((_, index) => index !== indexToRemove));
      };

      const [selectedAccounts, setSelectedAccounts] = useState([]);

      // Active platform filter for the "Post To" list: clicking a platform icon
      // shows ONLY that platform's accounts; clicking it again shows all.
      // '' = no filter. linkedin_page is grouped under linkedin.
      const [typeFilter, setTypeFilter] = useState('');

const [uploadedVideos, setUploadedVideos] = useState([]);

// X/Twitter reply thread ("first comment") — ordered list of reply tweets
const [replies, setReplies] = useState([]);
const addReply        = () => setReplies(prev => [...prev, '']);
const updateReply     = (i, val) => setReplies(prev => prev.map((r, idx) => idx === i ? val : r));
const removeReply     = (i) => setReplies(prev => prev.filter((_, idx) => idx !== i));

    const tooltipRef  = useRef(null);
    const myContext   = useAuth();
    const infoLoaded  = myContext.infoLoaded;

    const [errorMessage, seterrorMessage] = useState('');
    const [showModal2, setshowModal2] = useState(false);

  

    const [activeDraftId,     setactiveDraftId]     = useState(null);
    const [activeScheduledId, setactiveScheduledId] = useState(null);

 
    const [schedulePostModalShow, setschedulePostModalShow] = useState(false);
    const handleCloseScheduleModal = () => setschedulePostModalShow(false);
    const handleShowScheduleModal = () => setschedulePostModalShow(true);

  const [selectedDate, setSelectedDate] = useState(new Date());
  const handleDateChange = date => setSelectedDate(date);



  const [whatPostType, setwhatPostType] = useState(null)


const PostPreview = () => {
  return (
    <div className="preview-stage mb-4" style={{
      background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)', // Subtle tech-gradient
      padding: '30px 20px',
      borderRadius: '15px',
      border: '1px solid #dee2e6',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }}>
      {/* Label above the card */}
      <div className="d-flex align-items-center mb-3 w-100 justify-content-center">
        <span className="badge  px-3 py-2 shadow-sm" style={{ borderRadius: '20px', background: "rgb(47, 186, 1)", fontSize: '0.75rem' }}>
          <FontAwesomeIcon icon={faRocket} className="me-2" /> LIVE PREVIEW
        </span>
      </div>

      {/* The Actual Social Card */}
      <div className="card shadow-lg w-100" style={{ 
        maxWidth: '450px', 
        borderRadius: '12px', 
        overflow: 'hidden', 
        border: 'none',
        backgroundColor: '#ffffff'
      }}>
        <div className="card-body p-3">
          {/* Header: Avatar + Name */}
          <div className="d-flex align-items-center mb-3">
            <div 
              className="rounded-circle bg-primary d-flex align-items-center justify-content-center me-2" 
              style={{ width: '42px', height: '42px' }}
            >
              <FontAwesomeIcon icon={faSmile} className="text-white" />
            </div>
            <div>
              <div className="fw-bold mb-0" style={{ fontSize: '0.95rem', color: '#050505' }}>Your Brand Name</div>
              <div className="text-muted small">Just now · <Icon.Globe size={12} /></div>
            </div>
          </div>

          {/* Content Area */}
          <div className="post-content mb-3" style={{ 
            fontSize: '0.92rem', 
            whiteSpace: 'pre-wrap', 
            color: '#1c1e21',
            lineHeight: '1.4' 
          }}>
            {text || <span className="text-muted italic">Drafting your masterpiece...</span>}
          </div>

          {/* Media Preview Area */}
          {uploadedImages.length > 0 && (
            <div className="position-relative mb-2 rounded overflow-hidden" style={{ border: '1px solid #f0f2f5' }}>
               <img 
                 src={uploadedImages[0].url || uploadedImages[0]} 
                 alt="Preview" 
                 style={{ width: '100%', height: 'auto', maxHeight: '280px', objectFit: 'cover' }} 
               />
               {uploadedImages.length > 1 && (
                 <div className="position-absolute bottom-0 end-0 m-2 badge bg-dark opacity-75">
                   +{uploadedImages.length - 1} more
                 </div>
               )}
            </div>
          )}

{uploadedVideos.length > 0 && (
  <div className="mb-2 rounded overflow-hidden bg-dark shadow-sm" style={{ border: '1px solid #f0f2f5' }}>
    <video 
      controls 
      style={{ width: '100%', maxHeight: '350px', display: 'block' }}
      src={
        // 1. If it's a simple string (URL), use it directly
        typeof uploadedVideos[0] === 'string' 
          ? uploadedVideos[0] 
          // 2. If it's an object from the Media Library (has .file_url or .url)
          : (uploadedVideos[0].file_url || uploadedVideos[0].url) 
            ? (uploadedVideos[0].file_url || uploadedVideos[0].url)
            // 3. Fallback: Only use createObjectURL if it's a real File/Blob object
            : (uploadedVideos[0] instanceof Blob ? URL.createObjectURL(uploadedVideos[0]) : "")
      }
    >
      Your browser does not support the video tag.
    </video>
    {shortText && (
      <div className="bg-white p-2 border-top">
        <div className="fw-bold small text-truncate" style={{ color: '#050505' }}>{shortText}</div>
      </div>
    )}
  </div>
)}

          {/* Fake Interactions */}
          <div className="d-flex justify-content-between text-muted mt-3 pt-3 border-top" style={{ fontSize: '0.85rem' }}>
            <span className="d-flex align-items-center"><Icon.Heart size={16} className="me-1" /> Like</span>
            <span className="d-flex align-items-center"><Icon.MessageCircle size={16} className="me-1" /> Comment</span>
            <span className="d-flex align-items-center"><Icon.Share2 size={16} className="me-1" /> Share</span>
          </div>
        </div>
      </div>
      
      <small className="text-muted mt-3" style={{ fontSize: '0.7rem' }}>
        * Appearance may vary slightly across different networks.
      </small>
    </div>
  );
};



  const handleConfirmSchedulePost = async (date, postStatus = "publish") => {


    const m = Array.isArray(myContext.membership) ? myContext.membership[0] : myContext.membership;
    const isCancelled = m?.subscription_status === "cancelled";
    const isLifetime = m?.plan?.type === "lifetime" || (
        m?.end_date_time
            ? new Date(m.end_date_time.replace(' ', 'T') + 'Z').getTime() > Date.now() + 10 * 365 * 24 * 3600 * 1000
            : false
    );

    if ((!myContext.isValidMembership() || isCancelled) && !isLifetime) {
        seterrorMessage(
            "Your membership is inactive or has been cancelled. To continue scheduling posts, please renew your subscription at schedpilot.com/pricing."
        );
        handleShow(); // This opens your existing showModal2
        return;
    }

    
    if(myContext.isValidMembership() == false && !isLifetime)
    {
      alert("Your membership is expired. It cannot post.");
      return;
    }
   
    if(selectedAccounts.length == 0)
    {
        handleShow();
        seterrorMessage("You must select at least one social network to schedule your post.")
        return;
    }


    if(text.length < 10)
    {
        handleShow();

        seterrorMessage("You must start typing something to schedule as a post. Min 10 chars.")
        return;
    }


      if(shortText.length < 10 && whatPostType == "video_post")
    {
        handleShow();

        seterrorMessage("You must put a title to the video.")
        return;
    }


    const jwtToken = myContext.jwtToken;

    handleCloseScheduleModal();
    setloading(true);
    setdisabled(true);

    var currentScheduledID = 0;
    if(activeScheduledId != null ) currentScheduledID = activeScheduledId;
 


    const response = await fetch('https://api.schedpilot.com/wp-json/api/v1/schedulePost', {
      method: 'POST',
      credentials: 'include', 
      headers: {
        'Content-Type': 'application/json'
        
      },
      body: JSON.stringify({ scheduledDate: formatLocalDate(date), text: text, 
        currentScheduledID: currentScheduledID, postStatus: postStatus,
timezone: timezone,
        videoTitle: shortText,

        images: uploadedImages,
            videos: uploadedVideos,
accounts: selectedAccounts,
        replies: replies
       }),
    }).then(data => data.json()).then(MYJSON =>{

        console.log(MYJSON)

        setloading(false);
        setdisabled(false);

        // The API signals success ONLY with code === 200. Anything else
        // (401 auth, 429 rate/plan limit, 500 DB error) is a failure. Show the
        // server's message and KEEP every field so the user never loses their work.
        if (!MYJSON || MYJSON.code !== 200) {
            seterrorMessage(
                (MYJSON && (MYJSON.message || MYJSON.error)) ||
                "Something went wrong scheduling your post. Please try again."
            );
            handleShow();
            return;
        }

        // ---- success only past this point ----
        if(activeDraftId != null)
        {
          deleteDraft(activeDraftId);
          setactiveDraftId(null)
        }

        if(postStatus == "draft")
            toast.success("Draft saved successfully!");
        else
            toast.success("Post send to scheduler successfully!");

        if(activeScheduledId == null && MYJSON.data)
        {
            myContext.addScheduledItem(MYJSON.data);
        }

        // Clear the form only now that the post was actually saved.
        setText("");
        setShortText("");
        setUploadedImages([]);
        setUploadedVideos([]);
        setReplies([]);
        setGeneratedPosts([]);
        setactiveScheduledId(null);
        handleCloseScheduleModal();
    }).catch(err => {
        // Network / parse error — never wipe the form, just re-enable and inform.
        console.error('schedulePost failed:', err);
        setloading(false);
        setdisabled(false);
        seterrorMessage("A connection error occurred. Your post was not lost — please try again.");
        handleShow();
    });
  };

  // ── Approval email autocomplete ──────────────────────────────────────────
  const fetchEmailSuggestions = async (q) => {
    if (q.length < 2) { setEmailSuggestions([]); return; }
    try {
      const res = await fetch(
        `https://api.schedpilot.com/wp-json/api/v1/approval-email-suggestions?q=${encodeURIComponent(q)}`,
        { credentials: 'include' }
      );
      const data = await res.json();
      setEmailSuggestions(data.emails || []);
      if ((data.emails || []).length > 0) setShowEmailSuggestions(true);
    } catch {}
  };

  const handleApprovalEmailChange = (val) => {
    setApprovalEmail(val);
    clearTimeout(suggestionTimer.current);
    suggestionTimer.current = setTimeout(() => fetchEmailSuggestions(val), 300);
  };

  // ── Send for approval ────────────────────────────────────────────────────
  const handleSendForApproval = async () => {
    const m = Array.isArray(myContext.membership) ? myContext.membership[0] : myContext.membership;
    const isCancelled = m?.subscription_status === 'cancelled';
    const isLifetime = m?.plan?.type === "lifetime" || (
      m?.end_date_time
        ? new Date(m.end_date_time.replace(' ', 'T') + 'Z').getTime() > Date.now() + 10 * 365 * 24 * 3600 * 1000
        : false
    );
    if ((!myContext.isValidMembership() || isCancelled) && !isLifetime) {
      seterrorMessage('Your membership is inactive. Please renew to continue.');
      handleShow(); return;
    }
    if (selectedAccounts.length === 0) {
      seterrorMessage('You must select at least one social network.');
      handleShow(); return;
    }
    if (text.length < 10) {
      seterrorMessage('Post content must be at least 10 characters.');
      handleShow(); return;
    }
    if (!approvalEmail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(approvalEmail)) {
      seterrorMessage('Please enter a valid client email address.');
      handleShow(); return;
    }

    setloading(true);
    setdisabled(true);

    try {
      const res = await fetch('https://api.schedpilot.com/wp-json/api/v1/schedulePost', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          scheduledDate: formatLocalDate(selectedDate),
          text,
          currentScheduledID: 0,
          postStatus: 'pending_approval',
          approval_email: approvalEmail,
          timezone,
          videoTitle: shortText,
          images: uploadedImages,
          videos: uploadedVideos,
          accounts: selectedAccounts,
          replies: replies,
        }),
      }).then(r => r.json());

      if (res.code === 200) {
        toast.success(`Approval request sent to ${approvalEmail}!`);
        setText(''); setShortText(''); setReplies([]);
        setUploadedImages([]); setUploadedVideos([]);
        setRequireApproval(false); setApprovalEmail('');
      } else {
        seterrorMessage(res.error || 'Failed to send approval request.');
        handleShow();
      }
    } catch {
      seterrorMessage('A connection error occurred.');
      handleShow();
    } finally {
      setloading(false);
      setdisabled(false);
    }
  };

  //-------------

  const [loading, setloading] = useState(false);
  const [disabled, setdisabled] = useState(false);

  const navigate = useNavigate();

  const [text, setText] = useState('');
  const [showModal, setShowModal] = useState(false);

  const [shortText, setShortText] = useState('');

  const handleClose = () => setshowModal2(false);
  const handleShow = () => setshowModal2(true);

  const handleShortChange = (e) => {
  setShortText(e.target.value);
};


  useEffect(() => {
    function handleClickOutside(event) {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setShowModal(false);
      }
    }


    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);

    // Unbind the event listener on cleanup
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


    const handleToggleModal = () => {
        setShowModal(!showModal);
      };


    const handleChange = (event) => {
        setText(event.target.value);
      };

const shortTextInput = () => {
  return (
    <div className='mt-3 mb-1'>
      <textarea
        className='form-control'
        maxLength={100}
        style={{ minHeight: 60 }}
        value={shortText}
        placeholder='Enter a title for the video...'
        onChange={handleShortChange}
      ></textarea>
      <div className='text-muted small text-right'>
        {shortText.length}/100 characters
      </div>
    </div>
  );
};



const [isMagicLoading, setIsMagicLoading] = useState(false);
const [generatedPosts, setGeneratedPosts] = useState([]);

const handleDoMagic = async () => {
  if (!text.trim()) return;
  setIsMagicLoading(true);

  try {
    const res = await fetch('https://api.schedpilot.com/wp-json/api/v1/generate-post', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
      body: JSON.stringify({ prompt: text }),
    });

    const data = await res.json();
    // Expecting something like: { posts: [ '...', '...', '...' ] }
    setGeneratedPosts(data.posts || []);
  } catch (err) {
    console.error('Error generating posts', err);
  } finally {
    setIsMagicLoading(false);
  }
};


const handleUseGeneratedPost = (post) => {
  setText(post);
  // optional: scroll back to textarea
  // window.scrollTo({ top: 0, behavior: 'smooth' });
};


const isTwitterSelected = selectedAccounts.some(v => v.split('_')[1] === 'twitter');

const threadComposer = () => {
  return (
    <div className='mt-4 mb-1 p-3' style={{ border: '1px solid #e2e8f0', borderRadius: 12, background: '#f8fafc' }}>
      <h6 className='mb-1' style={{ fontWeight: 700, color: '#0f172a' }}>X / Twitter thread</h6>
      <p className='small text-muted mb-2'>
        Add reply tweets that we’ll post as a thread right after your main tweet (your “first comment”). Only sent to X / Twitter accounts.
      </p>

      {replies.map((rep, i) => (
        <div key={i} className='mb-2'>
          <div className='d-flex align-items-start' style={{ gap: 8 }}>
            <span className='text-muted small' style={{ marginTop: 8, minWidth: 16 }}>{i + 1}.</span>
            <textarea
              className='form-control'
              maxLength={280}
              style={{ minHeight: 60 }}
              value={rep}
              placeholder={`Reply tweet ${i + 1}...`}
              onChange={(e) => updateReply(i, e.target.value)}
            />
            <button
              type='button'
              className='btn btn-sm btn-outline-danger'
              style={{ marginTop: 2 }}
              onClick={() => removeReply(i)}
              title='Remove reply'
            >
              <Icon.X size={14} />
            </button>
          </div>
          <div className='text-muted small text-right'>{rep.length}/280 characters</div>
        </div>
      ))}

      <button type='button' className='btn btn-sm btn-outline-primary' onClick={addReply}>
        <Icon.Plus size={14} className='me-1' /> Add reply tweet
      </button>
    </div>
  );
};

const writeTextBox = () => {
  return (
    <>
    <div className='mb-1'>
      <textarea
        className='form-control'
        maxLength={2999}
        style={{ minHeight: 320 }}
        value={text}
        placeholder='Start composing your post...'
        onChange={handleChange}
      ></textarea>
      <div className='text-muted small text-right'>
        {text.length}/2999 characters
      </div>
    </div>


{/* Magic box */}
<div className="card magic-card border-0 shadow-sm mt-3">
  <div className="card-body d-flex flex-column flex-md-row justify-content-between align-items-md-center">
    <div className="mb-3 mb-md-0">
      <h6 className="mb-1">Need some inspiration?</h6>
      <p className="mb-0 small text-muted">
        Click <strong>“Do your magic”</strong> and we’ll generate 3 post ideas based on the text you wrote above.
      </p>
    </div>

    <div className="text-md-end">
      <button
        type="button"
        className="btn btn-primary"
        onClick={handleDoMagic}
        disabled={!text.trim() || isMagicLoading}
      >
        {isMagicLoading && (
          <span
            className="spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true"
          ></span>
        )}
        {isMagicLoading ? 'Generating…' : 'Do your magic'}
      </button>
    </div>
  </div>

  {/* Optional area to show the 3 generated posts */}
{generatedPosts?.length > 0 && (
  <div className="card-footer bg-transparent">
    <p className="small text-muted mb-2">AI-generated suggestions:</p>

    <div className="d-flex flex-column gap-3">
      {generatedPosts.map((post, idx) => (
        <div key={idx} className="card border-0  shadow-sm social-post-card">
          <div className="card-body d-flex flex-column">
            <div className="d-flex align-items-center mb-3">
              <div
                className="rounded-circle d-flex align-items-center justify-content-center me-2 social-avatar"
              >
                SP
              </div>
              <div>
                <div className="fw-semibold black-text">SchedPilot</div>
                <div className="small text-muted">
                  @schedpilot · Suggestion #{idx + 1}
                </div>
              </div>
            </div>

            <p className="small black-text flex-grow-1 mb-3" style={{ whiteSpace: 'pre-wrap' }}>
              {post.replace(/\\n/g, '\n')}
            </p>

            <button
              type="button"
              className="btn btn-outline-primary btn-sm mt-auto align-self-start"
              onClick={() => handleUseGeneratedPost(post)}
            >
              Use this version
            </button>
          </div>
        </div>
      ))}
    </div>
  </div>
)}

</div>



    </>
  );
};


  const toolsBox = () =>{
    return(<>
    <div className="row mt-3">
        <div className="col-12">
            <ul className='simpleList'>

            <li><button disabled={disabled}  onClick={()=>{
           
        }} className='btn   btn-white bnRadius'><FontAwesomeIcon icon={faFaceSmile} /></button></li>

            <li><button disabled={disabled}  onClick={()=>{
           
        }} className='btn   btn-white bnRadius'><FontAwesomeIcon icon={faFont} /></button></li>

        <li className='tooltip-container'><button disabled={disabled} onClick={()=>{
            handleToggleModal()
        }} className='btn   btn-white bnRadius'><FontAwesomeIcon icon={faRobot} /></button>
        
        {showToolTip()}
        
        </li>

        

       




            </ul>
        </div>
    </div>
    </>)
  }


  function scheduleit()
  {
    if(text.length < 25)
    {
            handleShow();
            seterrorMessage("You must start typing something to schedule as a post. Min 25 chars.")
    }
    else
    {
        handleShowScheduleModal();
    }
   
  }

  function saveDraft()
  {
    if(text.length < 25)
    {
            handleShow();
            seterrorMessage("You must start typing something to save as draft. Min 25 chars.")
    }
    else
    {
        setloading(true);
        setdisabled(true);

        var currentDraft = 0;

        if(activeDraftId != null)
          {
            currentDraft = activeDraftId
          }

        const jwtToken = myContext.jwtToken;
        fetch('https://api.schedpilot.com/wp-json/api/v1/saveDraft', {
            method: 'POST',
            credentials: 'include', 
            headers: {
                'Content-Type': 'application/json',
             
            },
            body: JSON.stringify({ textBoxContent:  text, currentDraft: currentDraft })
        }) .then(data => data.json()).then(MYJSON =>{


            setText("")
            setloading(false);
            setdisabled(false);
            
            console.log(MYJSON)


            const singleItem = {
              pid: MYJSON.post_id,
              content: text,
              scheduled_date: zuluToDate("2024-01-01 10:00:00")
          }

          myContext.addDraftItem(singleItem);
          setactiveDraftId(null)

            
        });

    }



  }




  function postWithAI(action)
  {

    if(text.length < 50)
    {
            handleShow();
            seterrorMessage("You must start typing a post to leverage AI tools. Min 50 chars.")
    }
    else
    {
        setloading(true);
        setdisabled(true);

            const jwtToken = myContext.jwtToken;
            fetch('https://api.schedpilot.com/wp-json/api/v1/postWithAI', {
                method: 'POST',
                credentials: 'include', 
                headers: {
                
                  
                },
                body: JSON.stringify({ textBoxContent:  text, action: action })
            }) .then(data => data.json()).then(MYJSON =>{
                
                if(action == "fix_grammar" || action == "add_emojis" || action == "add_hastags" || action == "create_cta" || action == "post_ideas" || action == "make_shorter")
                {
                    setText(MYJSON.answer)
                }
                else
                {
                    setText(text + "\n" + MYJSON.answer)
                }
                
                setloading(false);
                setdisabled(false);
                
                
            });

}

  }

  function showToolTip()
  {
    return (<>
    {showModal && (
        <div className="tooltip-new" ref={tooltipRef}>
          <div className="tooltip-content">
            
            <div class="row">
                <div class="col-12 mb-3 small_txt"><FontAwesomeIcon icon={faLightbulb} className='coloredIcon2' /> Use these AI tools to improve your post</div>
            <div class="col-6 mb-2"><a className="btn-ai-idea" onClick={() =>{ postWithAI("finish_post") }}><FontAwesomeIcon icon={faFlagCheckered} className='coloredIcon' /> Finish Post</a></div>
                <div class="col-6 mb-2"><a className="btn-ai-idea" onClick={() =>{ postWithAI("post_ideas") }}><FontAwesomeIcon icon={faRocket} className='coloredIcon' /> Post Ideas</a></div>
                <div class="col-6 mb-2"><a className="btn-ai-idea" onClick={() =>{ postWithAI("create_cta") }}><FontAwesomeIcon icon={faStar} className='coloredIcon' /> Create CTA</a></div>
                <div class="col-6 mb-2"><a className="btn-ai-idea" onClick={() =>{ postWithAI("make_shorter") }}><FontAwesomeIcon icon={faDownLeftAndUpRightToCenter} className='coloredIcon' /> Make Shorter</a></div>
                <div class="col-6 mb-2"><a className="btn-ai-idea" onClick={() =>{ postWithAI("make_longer") }}><FontAwesomeIcon icon={faUpRightAndDownLeftFromCenter} className='coloredIcon' /> Make Longer</a></div>
                <div class="col-6 mb-2"><a className="btn-ai-idea" onClick={() =>{ postWithAI("add_emojis") }}><FontAwesomeIcon icon={faFaceSmile} className='coloredIcon' /> Add Emojis</a></div>
                <div class="col-6 mb-2"><a className="btn-ai-idea" onClick={() =>{ postWithAI("active_voice") }}><FontAwesomeIcon icon={faDumbbell} className='coloredIcon' /> Active Voice</a></div>
                <div class="col-6 mb-2"><a className="btn-ai-idea" onClick={() =>{ postWithAI("fix_grammar") }}><FontAwesomeIcon icon={faCog} className='coloredIcon' /> Fix Grammar</a></div>
                <div class="col-6 mb-2"><a className="btn-ai-idea" onClick={() =>{ postWithAI("make_formal") }}><FontAwesomeIcon icon={faUserTie} className='coloredIcon' /> More Formal</a></div>
                <div class="col-6 mb-2"><a className="btn-ai-idea" onClick={() =>{ postWithAI("improve_post") }}><FontAwesomeIcon icon={faWandMagic} className='coloredIcon' /> Improve Post</a></div>
                <div class="col-6 mb-2"><a className="btn-ai-idea" onClick={() =>{ postWithAI("add_hastags") }}><FontAwesomeIcon icon={faWandMagic} className='coloredIcon' /> Add Hastags</a></div>
                <div class="col-6 mb-2"><a className="btn-ai-idea" onClick={() =>{ postWithAI("add_listicle") }}><FontAwesomeIcon icon={faWandMagic} className='coloredIcon' /> Add Listicle</a></div>
            </div>
          </div>
        </div>
      )}
      </>)
  }


  const [activeTab, setActiveTab] = useState('tab1');

 
 

  //---------------------------------------------
  //
  //    function
  //
  //---------------------------------------------

  function deleteDraft(item, index)
  {
    setloading(true);

    const jwtToken = myContext.jwtToken;
    fetch('https://api.schedpilot.com/wp-json/api/v1/deleteDraft', {
        method: 'POST',credentials: 'include', 
        headers: {
            'Content-Type': 'application/json', 
        },
        body: JSON.stringify({ pid:  item.pid })
    }) .then(data => data.json()).then(MYJSON =>{
        
      myContext.removeFromDrafts(index);

        
        setloading(false);
        
        
    });
  }


        const mySocialAccounts = myContext.accounts;

const platformIcons = {
  twitter: ximage, linkedin: linkedinimage, linkedin_page: linkedinimage,
  youtube: youtubeimage, instagram, threads: threadsimage,
  facebook: facebookimage, tiktok, bluesky: blueskyimage, pinterest,
  discord: discordimage,
};

const displaySelectedAccounts = selectedAccounts.map(idType => {
  const sep = idType.indexOf('_');
  const id   = idType.slice(0, sep);
  const type = idType.slice(sep + 1);
  return mySocialAccounts.find(acc =>
    acc.id.toString() === id && acc.type === type
  );
}).filter(Boolean);

 

const formatLocalDate = (date) => {
  const pad = (num) => String(num).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
};


useEffect(() => {
  const dateParam = queryParams.get('date');
  const timeParam = queryParams.get('time'); // e.g., "14:30"

  if (dateParam) {
    const [year, month, day] = dateParam.split('-').map(Number);
    const newDate = new Date();
    newDate.setFullYear(year);
    newDate.setMonth(month - 1);
    newDate.setDate(day);

    // If time is provided, split and set it
    if (timeParam) {
      const [hours, minutes] = timeParam.split(':').map(Number);
      newDate.setHours(hours, minutes, 0);
    } else {
      newDate.setHours(9, 0, 0); // Default fallback
    }

    setSelectedDate(newDate);

    if (!whatPostType) {
      setwhatPostType("text_image");
    }
  }
}, [location.search]);


  return (
  
  
    <MainStructure activeItem={"write-post"}>

  


<Modal show={schedulePostModalShow} onHide={handleCloseScheduleModal}>
      <Modal.Header closeButton>
        <Modal.Title>Schedule Your Post</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Select your date and time to publish your post on social networks</p>
        <DatePicker
          selected={selectedDate}
          onChange={handleDateChange}
          showTimeSelect
          timeIntervals={10} // Set time intervals to 30 minutes
          timeCaption="Time"
          dateFormat="MMMM d, yyyy h:mm aa"
          className="form-control" 
  wrapperClassName="w-100"
        />


        <p className='mt-3'>Post on:</p>


        {

            mySocialAccounts.length == 0 ?


              <p>There are no connected accounts yet.</p>


              :

              <div className=''>
{mySocialAccounts
  .filter((account) => account.type != "tiktok") // This line removes TikTok accounts
  .map((account) => {
    const accountValue = `${account.id}_${account.type}`;

    const handleCheckboxChange = (event) => {
      const { checked, value } = event.target;

      setSelectedAccounts((prevSelected) => {
        if (checked) {
          return [...prevSelected, value];
        } else {
          return prevSelected.filter((item) => item !== value);
        }
      });
    };

    return (
      <label key={accountValue} htmlFor={`modal-account-${accountValue}`} style={{
        display: 'flex', alignItems: 'center', gap: 10, borderRadius: 8,
        padding: '8px 10px', marginBottom: 4, cursor: 'pointer',
        background: selectedAccounts.includes(accountValue) ? '#eff6ff' : 'transparent',
        border: selectedAccounts.includes(accountValue) ? '1px solid #c7d7fd' : '1px solid transparent',
        transition: 'background 0.15s',
      }}>
        <div style={{ position: 'relative', flexShrink: 0 }}>
          <AccountAvatar src={account.image} name={account.name} size={34} />
          {platformIcons[account.type] && (
            <div style={{ position: 'absolute', bottom: -2, right: -2 }}>
              <img src={platformIcons[account.type]} alt={account.type} style={{ width: 14, height: 14, borderRadius: '50%', background: '#fff', padding: 1 }} />
            </div>
          )}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontWeight: 600, fontSize: '0.85rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{account.name}</div>
          <div style={{ fontSize: '0.72rem', color: '#94a3b8', textTransform: 'capitalize' }}>{account.type}</div>
        </div>
        <input id={`modal-account-${accountValue}`} type='checkbox' value={accountValue} checked={selectedAccounts.includes(accountValue)} onChange={handleCheckboxChange} style={{ width: 16, height: 16, flexShrink: 0, cursor: 'pointer' }} />
      </label>
    );
})}


              </div>



        }



   
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseScheduleModal}>
          Close
        </Button>
        <Button variant="primary" onClick={() => handleConfirmSchedulePost(selectedDate)}>
          Schedule Post
        </Button>
      </Modal.Footer>
    </Modal>


<Modal show={showModal2} onHide={handleClose}>
        <Modal.Body style={{backgroundColor:"#F7918F", color: "black"}}>
         {errorMessage}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            Close
          </Button>
 
        </Modal.Footer>
      </Modal>


      {
        infoLoaded == true ?


        <>
        {

        whatPostType == null ?

<div className="container p-0">

      {myContext.returnMembershipNotification()}

      <h1 style={{ fontWeight: 800, fontSize: '1.6rem', marginBottom: 4 }}>Create a Post</h1>
      <p style={{ color: '#64748b', marginBottom: 24 }}>Choose the type of post you'd like to create.</p>

<div className="row g-4">
  {/* Story Post */}
  <div className="col-md-4">
    <div style={{ background: '#fff', border: '1px solid #e8edf2', borderRadius: 14, padding: 24, height: '100%', display: 'flex', flexDirection: 'column' }}>
      <div style={{ background: '#f0f9ff', borderRadius: 12, padding: 14, display: 'inline-flex', marginBottom: 16 }}>
        <img src={teext} alt="Story Post" style={{ width: 70, height: 70 }} />
      </div>
      <h5 style={{ fontWeight: 700, marginBottom: 8 }}>Story Post</h5>
      <p style={{ color: '#64748b', fontSize: '0.9rem', flex: 1 }}>Share a text-post with image support. (LinkedIn, Twitter, Threads, Instagram)</p>
      <button style={{ background: '#4f46e5', border: 'none', borderRadius: 9, padding: '10px 0', fontWeight: 600, fontSize: '0.875rem', color: '#fff', cursor: 'pointer', width: '100%', marginTop: 8 }} onClick={() => setwhatPostType("text_image")}>
        Write Text Post
      </button>
    </div>
  </div>

  {/* General Video Post */}
  <div className="col-md-4">
    <div style={{ background: '#fff', border: '1px solid #e8edf2', borderRadius: 14, padding: 24, height: '100%', display: 'flex', flexDirection: 'column' }}>
      <div style={{ background: '#f0f9ff', borderRadius: 12, padding: 14, display: 'inline-flex', marginBottom: 16 }}>
        <img src={vidd} alt="Video Post" style={{ width: 70, height: 70 }} />
      </div>
      <h5 style={{ fontWeight: 700, marginBottom: 8 }}>General Video Post</h5>
      <p style={{ color: '#64748b', fontSize: '0.9rem', flex: 1 }}>Engage your audience on YouTube, LinkedIn, or Instagram.</p>
      <button style={{ background: '#4f46e5', border: 'none', borderRadius: 9, padding: '10px 0', fontWeight: 600, fontSize: '0.875rem', color: '#fff', cursor: 'pointer', width: '100%', marginTop: 8 }} onClick={() => setwhatPostType("video_post")}>
        Post Video
      </button>
    </div>
  </div>

  {/* TikTok Dedicated Post */}
  <div className="col-md-4">
    <div style={{ background: '#fff', border: '1px solid #e8edf2', borderRadius: 14, padding: 24, height: '100%', display: 'flex', flexDirection: 'column' }}>
      <div style={{ background: '#f0f9ff', borderRadius: 12, padding: 14, display: 'inline-flex', marginBottom: 16 }}>
        <img src={tiktok} alt="TikTok" style={{ width: 70, height: 70 }} />
      </div>
      <h5 style={{ fontWeight: 700, marginBottom: 8 }}>TikTok Post</h5>
      <p style={{ color: '#64748b', fontSize: '0.9rem', flex: 1 }}>Directly publish videos to TikTok with account-specific validation.</p>
      <button style={{ background: '#0f172a', border: 'none', borderRadius: 9, padding: '10px 0', fontWeight: 600, fontSize: '0.875rem', color: '#fff', cursor: 'pointer', width: '100%', marginTop: 8 }} onClick={() => navigate('/post-tiktok')}>
        Post to TikTok
      </button>
    </div>
  </div>

  {/* Pinterest Dedicated Post */}
  <div className="col-md-4">
    <div style={{ background: '#fff', border: '1px solid #e8edf2', borderRadius: 14, padding: 24, height: '100%', display: 'flex', flexDirection: 'column' }}>
      <div style={{ background: '#f0f9ff', borderRadius: 12, padding: 14, display: 'inline-flex', marginBottom: 16 }}>
        <img src={pinterest} alt="Pinterest" style={{ width: 70, height: 70 }} />
      </div>
      <h5 style={{ fontWeight: 700, marginBottom: 8 }}>Pinterest Post</h5>
      <p style={{ color: '#64748b', fontSize: '0.9rem', flex: 1 }}>Post images to Pinterest with destination links and descriptions.</p>
      <button style={{ background: '#e60023', border: 'none', borderRadius: 9, padding: '10px 0', fontWeight: 600, fontSize: '0.875rem', color: '#fff', cursor: 'pointer', width: '100%', marginTop: 8 }} onClick={() => navigate('/post-pinterest')}>
        Create Pin
      </button>
    </div>
  </div>

  {/* LinkedIn Carousel (document post) */}
  <div className="col-md-4">
    <div style={{ background: '#fff', border: '1px solid #e8edf2', borderRadius: 14, padding: 24, height: '100%', display: 'flex', flexDirection: 'column' }}>
      <div style={{ background: '#f0f9ff', borderRadius: 12, padding: 14, display: 'inline-flex', marginBottom: 16 }}>
        <img src={linkedinimage} alt="LinkedIn" style={{ width: 70, height: 70 }} />
      </div>
      <h5 style={{ fontWeight: 700, marginBottom: 8 }}>LinkedIn Carousel</h5>
      <p style={{ color: '#64748b', fontSize: '0.9rem', flex: 1 }}>Turn a set of images into swipeable slides on your LinkedIn profile or company page.</p>
      <button style={{ background: '#0a66c2', border: 'none', borderRadius: 9, padding: '10px 0', fontWeight: 600, fontSize: '0.875rem', color: '#fff', cursor: 'pointer', width: '100%', marginTop: 8 }} onClick={() => navigate('/post-linkedin-carousel')}>
        Create Carousel
      </button>
    </div>
  </div>

  {/* Instagram Story */}
  <div className="col-md-4">
    <div style={{ background: '#fff', border: '1px solid #e8edf2', borderRadius: 14, padding: 24, height: '100%', display: 'flex', flexDirection: 'column' }}>
      <div style={{ background: '#fdf2f8', borderRadius: 12, padding: 14, display: 'inline-flex', marginBottom: 16 }}>
        <img src={instagram} alt="Instagram" style={{ width: 70, height: 70 }} />
      </div>
      <h5 style={{ fontWeight: 700, marginBottom: 8 }}>Instagram Story</h5>
      <p style={{ color: '#64748b', fontSize: '0.9rem', flex: 1 }}>Schedule an image or short video to appear in your Instagram story for 24 hours.</p>
      <button style={{ background: 'linear-gradient(90deg,#feda75,#d62976 45%,#962fbf)', border: 'none', borderRadius: 9, padding: '10px 0', fontWeight: 600, fontSize: '0.875rem', color: '#fff', cursor: 'pointer', width: '100%', marginTop: 8 }} onClick={() => navigate('/post-instagram-story')}>
        Create Story
      </button>
    </div>
  </div>

  {/* Instagram Carousel */}
  <div className="col-md-4">
    <div style={{ background: '#fff', border: '1px solid #e8edf2', borderRadius: 14, padding: 24, height: '100%', display: 'flex', flexDirection: 'column' }}>
      <div style={{ background: '#fdf2f8', borderRadius: 12, padding: 14, display: 'inline-flex', marginBottom: 16 }}>
        <img src={instagram} alt="Instagram" style={{ width: 70, height: 70 }} />
      </div>
      <h5 style={{ fontWeight: 700, marginBottom: 8 }}>Instagram Carousel</h5>
      <p style={{ color: '#64748b', fontSize: '0.9rem', flex: 1 }}>Post up to 10 images as one swipeable feed post, with optional text on each image.</p>
      <button style={{ background: 'linear-gradient(90deg,#feda75,#d62976 45%,#962fbf)', border: 'none', borderRadius: 9, padding: '10px 0', fontWeight: 600, fontSize: '0.875rem', color: '#fff', cursor: 'pointer', width: '100%', marginTop: 8 }} onClick={() => navigate('/post-instagram-carousel')}>
        Create Carousel
      </button>
    </div>
  </div>
</div>
</div>

:
    

    <div className="container p-0">

      {myContext.returnMembershipNotification()}
    <div className='row'>
<div className='col-12 col-md-7 '>

    <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
      <button onClick={() => setwhatPostType(null)} style={{ background: 'none', border: '1px solid #e2e8f0', borderRadius: 8, padding: '6px 12px', cursor: 'pointer', color: '#64748b', display: 'flex', alignItems: 'center', gap: 6, fontSize: '0.85rem', fontWeight: 500 }}>
        <Icon.ArrowLeft size={14} /> Back
      </button>
      <div>
        <h1 style={{ fontWeight: 800, fontSize: '1.4rem', margin: 0, color: '#0f172a' }}>
          {whatPostType === 'video_post' ? 'New Video Post' : 'New Post'}
        </h1>
      </div>
    </div>

   {
                whatPostType == "video_post" ?
                        
                shortTextInput() : null }


    {writeTextBox()}

    {isTwitterSelected && threadComposer()}


{whatPostType === "text_image" && (
    <>
        <h4 className='mt-3'>Upload Images</h4>
        <ImageUploader
            uploadedImages={uploadedImages}
            setUploadedImages={setUploadedImages}
            removeUploadedImages={removeImage}
        />

        <div className="mt-2">
            <Button variant="outline-secondary" size="sm" onClick={() => setShowImagePicker(true)}>
                <Icon.Database size={14} className="me-1" /> Choose from Media Library
            </Button>
        </div>

        <MediaPicker
            show={showImagePicker}
            onHide={() => setShowImagePicker(false)}
            type="images"
            onSelect={(image) => {
                // The library returns {id, file_url}; the uploader stores {id, url}.
                if (uploadedImages.find(img => img.id === image.id)) {
                    toast.info("This image is already attached.");
                } else {
                    setUploadedImages([...uploadedImages, { url: image.file_url, id: image.id }]);
                    toast.success("Image added from library!");
                }
                setShowImagePicker(false);
            }}
        />
    </>
)}

        

{whatPostType === "video_post" && (
    <>
        <h4 className='mt-3'>Upload Videos</h4>
        <VideoUploader uploadedVideos={uploadedVideos} setUploadedVideos={setUploadedVideos} />
        
        <div className="mt-2">
            <Button variant="outline-secondary" size="sm" onClick={() => setShowMediaPicker(true)}>
                <Icon.Database size={14} className="me-1" /> Choose from Media Library
            </Button>
        </div>

        <MediaPicker 
            show={showMediaPicker} 
            onHide={() => setShowMediaPicker(false)} 
            type="videos"
            onSelect={(video) => {
                // Prevent duplicate selections
                if (!uploadedVideos.find(v => v.id === video.id)) {
                    setUploadedVideos([...uploadedVideos, video]);
                }
                setShowMediaPicker(false);
                toast.success("Video added from library!");
            }}
        />
    </>
)}









    {toolsBox()}

{ loading == true ?
<div className='mt-4'>
    <Spinner animation="border" role="status">
          <span className="sr-only">Loading...</span>
        </Spinner></div> : null }

      </div>

<div className='col-12 col-md-5 '>

{/* Selected Accounts Horizontal Bar */}
 
  <div className="card mb-3 p-2 shadow-sm border-1" style={{ borderRadius: '12px', background: '#fff' }}>
    <div className="small text-muted mb-2 ps-1" style={{ fontSize: '0.7rem', fontWeight: 'bold', textTransform: 'uppercase' }}>
      Posting to ({displaySelectedAccounts.length})
    </div>
    <div className="d-flex flex-wrap gap-2" style={{minHeight: '50px'}}>
      {displaySelectedAccounts.map((account) => (
        <div
          key={`${account.id}_${account.type}`}
          className="position-relative d-inline-block"
          title={account.name}
          style={{ cursor: 'default' }}
        >
          {/* Main Account Avatar */}
          <AccountAvatar src={account.image} name={account.name} size={44} />

          {/* Small Social Icon Overlay */}
          {platformIcons[account.type] && (
            <div style={{ position: 'absolute', bottom: -2, right: -2 }}>
              <img src={platformIcons[account.type]} alt={account.type} style={{ height: 20, width: 20, borderRadius: '50%', background: '#fff', padding: 1 }} />
            </div>
          )}
        </div>
      ))}
    </div>
  </div>
 

 

  {PostPreview()}

{
  postInspiration != null ?

<PostInspirationCard post={postInspiration}></PostInspirationCard> : null }


  { /*----------------------------------------*/ }

<div style={{ background: '#fff', border: '1px solid #e8edf2', borderRadius: 12, overflow: 'hidden', padding: '16px' }}>

  <div style={{ fontSize: '0.72rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: '#64748b', marginBottom: 8 }}>Schedule</div>

        <DatePicker
          selected={selectedDate}
          onChange={handleDateChange}
          showTimeSelect
          timeIntervals={10} // Set time intervals to 30 minutes
          timeCaption="Time" style={{padding:10}}
          dateFormat="MMMM d, yyyy h:mm aa"
className="form-control" 
  wrapperClassName="w-100"
        />


<TimezoneSelector 
    value={timezone} 
    onChange={setTimezone} 
    label="Scheduling Timezone"
    className="mt-2"
  />
  <small className="text-muted d-block mt-1" style={{ fontSize: '0.75rem' }}>
    Post will be scheduled based on this timezone.
  </small>

  <div style={{ fontSize: '0.72rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: '#64748b', margin: '16px 0 8px' }}>Post To</div>

  {/* Platform filter — click an icon to show ONLY that platform's accounts;
      click it again (or "All") to reset. Mirrors the single-post screen. */}
  {mySocialAccounts.length > 0 && (() => {
    // linkedin_page shares the linkedin icon, so group them. TikTok is excluded
    // from this list (same as the account list below).
    const typeKey = (t) => (t === 'linkedin_page' ? 'linkedin' : t);
    const listAccounts = mySocialAccounts.filter(a => a.type !== 'tiktok');
    const types = [...new Set(listAccounts.map(a => typeKey(a.type)))];
    if (types.length < 2) return null;
    return (
      <div className="d-flex align-items-center flex-wrap" style={{ gap: 6, marginBottom: 10 }}>
        <button
          type="button"
          onClick={() => setTypeFilter('')}
          title="Show all accounts"
          style={{
            border: typeFilter === '' ? '1px solid #c7d7fd' : '1px solid #e2e8f0',
            background: typeFilter === '' ? '#eff6ff' : '#fff',
            color: typeFilter === '' ? '#4f46e5' : '#64748b',
            borderRadius: 8,
            padding: '4px 9px',
            cursor: 'pointer',
            fontSize: '0.75rem',
            fontWeight: 700,
            lineHeight: '22px',
          }}
        >
          All
        </button>
        {types.map(t => {
          const active = typeFilter === t;
          const count = listAccounts.filter(a => typeKey(a.type) === t).length;
          return (
            <button
              key={t}
              type="button"
              onClick={() => setTypeFilter(active ? '' : t)}
              title={active ? 'Show all accounts' : `Show only ${t} accounts (${count})`}
              style={{
                border: active ? '1px solid #4f46e5' : '1px solid #e2e8f0',
                background: active ? '#eff6ff' : '#fff',
                borderRadius: 8,
                padding: 4,
                cursor: 'pointer',
                lineHeight: 0,
                opacity: typeFilter && !active ? 0.45 : 1,
                filter: typeFilter && !active ? 'grayscale(1)' : 'none',
                boxShadow: active ? '0 0 0 2px #c7d2fe' : 'none',
                transition: 'opacity 0.15s, filter 0.15s, box-shadow 0.15s',
              }}
            >
              <img src={platformIcons[t]} alt={t} style={{ width: 22, height: 22 }} />
            </button>
          );
        })}
      </div>
    );
  })()}

        {

            mySocialAccounts.length == 0 ?


              <p>There are no connected accounts yet.</p>


              :

              // need to have this div scrollable if too many accounts

              <div className='overflow-auto' style={{ maxHeight: 300 }}>

{mySocialAccounts
  .filter((account) => account.type !== "tiktok") // Exclude TikTok from the list
  .filter((account) => !typeFilter || (account.type === 'linkedin_page' ? 'linkedin' : account.type) === typeFilter)
  .map((account) => {
    const accountValue = `${account.id}_${account.type}`;

    const handleCheckboxChange = (event) => {
      const { checked, value } = event.target;

      setSelectedAccounts((prevSelected) => {
        if (checked) {
          return [...prevSelected, value];
        } else {
          return prevSelected.filter((item) => item !== value);
        }
      });
    };

    return (
      <label key={accountValue} htmlFor={`account-${accountValue}`} style={{
        display: 'flex', alignItems: 'center', gap: 10, borderRadius: 8,
        padding: '8px 10px', marginBottom: 4, cursor: 'pointer',
        background: selectedAccounts.includes(accountValue) ? '#eff6ff' : 'transparent',
        border: selectedAccounts.includes(accountValue) ? '1px solid #c7d7fd' : '1px solid transparent',
        transition: 'background 0.15s',
      }}>
        <div style={{ position: 'relative', flexShrink: 0 }}>
          <AccountAvatar src={account.image} name={account.name} size={34} />
          {platformIcons[account.type] && (
            <div style={{ position: 'absolute', bottom: -2, right: -2 }}>
              <img src={platformIcons[account.type]} alt={account.type} style={{ width: 14, height: 14, borderRadius: '50%', background: '#fff', padding: 1 }} />
            </div>
          )}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontWeight: 600, fontSize: '0.85rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{account.name}</div>
          <div style={{ fontSize: '0.72rem', color: '#94a3b8', textTransform: 'capitalize' }}>{account.type}</div>
        </div>
        <input id={`account-${accountValue}`} type='checkbox' value={accountValue} checked={selectedAccounts.includes(accountValue)} onChange={handleCheckboxChange} style={{ width: 16, height: 16, flexShrink: 0, cursor: 'pointer' }} />
      </label>
    );
})}            </div>
        }



{/* ── Client Approval Toggle ─────────────────────────────────── */}
<div style={{ marginTop: 14, padding: '12px 14px', background: '#f8fafc', borderRadius: 10, border: '1px solid #e2e8f0' }}>
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
    <div>
      <div style={{ fontWeight: 600, fontSize: '0.85rem', color: '#1e293b' }}>Require Client Approval</div>
      <div style={{ fontSize: '0.72rem', color: '#94a3b8', marginTop: 2 }}>Send post to client for review before publishing</div>
    </div>
    <div
      onClick={() => setRequireApproval(v => !v)}
      style={{
        width: 44, height: 24, borderRadius: 12, flexShrink: 0, cursor: 'pointer',
        background: requireApproval ? '#7c3aed' : '#cbd5e1',
        position: 'relative', transition: 'background 0.2s',
      }}
    >
      <div style={{
        position: 'absolute', top: 3, left: requireApproval ? 23 : 3,
        width: 18, height: 18, borderRadius: '50%', background: '#fff',
        boxShadow: '0 1px 3px rgba(0,0,0,0.2)', transition: 'left 0.2s',
      }} />
    </div>
  </div>

  {requireApproval && (
    <div style={{ marginTop: 12, position: 'relative' }}>
      <label style={{ fontSize: '0.78rem', fontWeight: 600, color: '#475569', marginBottom: 4, display: 'block' }}>
        Client Email
      </label>
      <input
        type="email"
        value={approvalEmail}
        onChange={e => handleApprovalEmailChange(e.target.value)}
        onFocus={() => approvalEmail.length >= 2 && fetchEmailSuggestions(approvalEmail)}
        onBlur={() => setTimeout(() => setShowEmailSuggestions(false), 150)}
        placeholder="client@example.com"
        style={{
          width: '100%', padding: '8px 10px', borderRadius: 8,
          border: '1px solid #e2e8f0', fontSize: '0.85rem',
          outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit',
        }}
      />
      {showEmailSuggestions && emailSuggestions.length > 0 && (
        <div style={{
          position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 999,
          background: '#fff', border: '1px solid #e2e8f0', borderRadius: 8,
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)', marginTop: 2, overflow: 'hidden',
        }}>
          {emailSuggestions.map((s, i) => (
            <div
              key={i}
              onMouseDown={() => { setApprovalEmail(s); setShowEmailSuggestions(false); }}
              style={{
                padding: '8px 12px', fontSize: '0.83rem', cursor: 'pointer',
                color: '#1e293b', borderBottom: i < emailSuggestions.length - 1 ? '1px solid #f1f5f9' : 'none',
              }}
              onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
              onMouseLeave={e => e.currentTarget.style.background = '#fff'}
            >
              {s}
            </div>
          ))}
        </div>
      )}
    </div>
  )}
</div>

<div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
  <button disabled={disabled} onClick={() => handleConfirmSchedulePost(selectedDate, "draft")}
    style={{ flex: 1, background: '#fff', border: '1px solid #e2e8f0', borderRadius: 9, padding: '9px 0', fontWeight: 600, fontSize: '0.875rem', color: '#475569', cursor: disabled ? 'not-allowed' : 'pointer' }}>
    Save Draft
  </button>
  {requireApproval ? (
    <button disabled={disabled} onClick={handleSendForApproval}
      style={{ flex: 2, background: '#7c3aed', border: 'none', borderRadius: 9, padding: '9px 0', fontWeight: 600, fontSize: '0.875rem', color: '#fff', cursor: disabled ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
      ✉ Send for Approval
    </button>
  ) : (
    <button disabled={disabled} onClick={() => handleConfirmSchedulePost(selectedDate)}
      style={{ flex: 2, background: '#4f46e5', border: 'none', borderRadius: 9, padding: '9px 0', fontWeight: 600, fontSize: '0.875rem', color: '#fff', cursor: disabled ? 'not-allowed' : 'pointer' }}>
      Schedule Post
    </button>
  )}
</div></div>



  </div>
   </div>
  </div>
  
  }
  </>
  : <LoadingSpinner></LoadingSpinner> }

    </MainStructure>



  )
}

export default WritePost